<template>
  <header>
    <!-- <a href="https://www.shinseibank.com"><img src="https://www.shinseibank.com/common09/imgs/popup_header_wave.jpg" alt=""></a> -->
    <img src="../assets/logo.png" width="159px" />
    <div class="header-hr" />
  </header>
</template>

<script>
export default {
  name: 'Header',
  props: {
  }
}
</script>
<style scoped>
</style>
